
export var API_URL = `https://api.deepdigital.nl`
export var API_LOGIN_URL = `https://api.deepdigital.nl`
export var CKEY = window.location.host.split('.')[0];
export var DEVMODE = false
export var IMAGE_URL = `https://api.deepdigital.nl/upload`

if(window.location.host == 'localhost:8081' || window.location.host == 'localhost:8080'){
  //API_URL = `https://demo.plandem.local:10443`
  //API_URL = `https://demo.plandem.local:10443`
  
  API_URL       = `https://192.168.178.111/`
  API_LOGIN_URL = `https://192.168.178.111/`

  CKEY = 'dev'

  // API_URL = `https://api.deepdigital.nl`
  // API_LOGIN_URL = `https://api.deepdigital.nl`
  // CKEY = 'adj'

  IMAGE_URL     = `https://192.168.178.111/upload`
  //CKEY = 'dev'
  //API_URL = `https://cycloon.plandem.local:10443`
  //API_URL = `https://smb2.plandem.local:10443`
  //API_URL = `https://cycloon.plandem.nl:10443`
  //API_URL = `https://accremon.plandem.nl:10443`
  //API_URL = `https://tin.plandem.nl:10443`
  DEVMODE = true
  console.log('RUNNING DEV API : ', API_URL)
}
// else if(window.location.host.split('.').pop() == 'local')
// {
//   API_URL = `https://${window.location.host.split('.')[0]}.plandem.local:10443`
//   DEVMODE = true
//   console.log('RUNNING DEV (PLANDEM.LOCAL) API : ', API_URL)
// }

console.log("USING API : ", API_URL)

//export const MAP_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
export const MAP_URL = 'https://api.maptiler.com/maps/streets/256/{z}/{x}/{y}.png?key=ls1rA6TD9ZA1fN6OCTAz'
export const SAT_MAP_URL = 'https://api.maptiler.com/maps/hybrid/256/{z}/{x}/{y}.jpg?key=ls1rA6TD9ZA1fN6OCTAz'
export const DARK_MAP_URL = 'https://api.maptiler.com/maps/darkmatter/{z}/{x}/{y}.png?key=ls1rA6TD9ZA1fN6OCTAz'
export const POSITRON_MAP_URL = 'https://api.maptiler.com/maps/positron/{z}/{x}/{y}.png?key=ls1rA6TD9ZA1fN6OCTAz'

export const NOTIFICATION_DEFAULT_TIMEOUT = 4000;
export const NOTIFICATION_DEFAULT_COLOR   = "error";

// export const colors = {   
//     primary: '#62A1D3',
//     secondary: '#37c6f2',
//     accent: '#FF5722',
//     error: '#f44336',
//     warning: '#ff9800',
//     info: '#03a9f4',
//     success: '#8bc34a',
//     errorWithActionColor: '#7d46ed'
// }

export const colors = {   
  primary: '#2C3E50',
  secondary: '#37c6f2',
  accent: '#FF5722',
  error: '#f44336',
  warning: '#ff9800',
  info: '#03a9f4',
  success: '#8bc34a',
  errorWithActionColor: '#7d46ed'
 }
